/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UpdateContractReviewerResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'ContractReviewer',
        isRequired: true,
      },
    },
  }],
} as const;
